import { defineComponent as _defineComponent } from 'vue'
import PortfolioVestingLine from "@/components/portfolio/PortfolioVestingLine.vue";
import {useUserStore} from "@/store/user.store";
import {VestingPeriods} from "@/models/store/account";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioVesting',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();

const continuousVestingData = computed(() => userStore.getAccount.continuousVestingData);
const accountType = computed(() => userStore.getAccountType);

// variable changing format of continuousVestingData to the same type like vesting period to ise the same component
let contVestingDetails = computed(() => {
  if (continuousVestingData.value) {
    return [{
      startTime: continuousVestingData.value.startTime.getTime() / 1000,
      endTime: continuousVestingData.value.endTime.getTime() / 1000,
      amount: continuousVestingData.value.originalVesting
    }];
  }
  else return [];
});

// filter completed vestings and sort them
const filterVestingArray = (array: VestingPeriods[] | undefined) => {
  return array?.filter(element => {
    return new Date(element.endTime*1000).getTime() - Date.now() > 0;
  }).sort((a,b) => a.endTime - b.endTime);
};


const __returned__ = { userStore, continuousVestingData, accountType, get contVestingDetails() { return contVestingDetails }, set contVestingDetails(v) { contVestingDetails = v }, filterVestingArray, PortfolioVestingLine }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})